import { render, staticRenderFns } from "./SmeBadge.vue?vue&type=template&id=17de6a2a&scoped=true&"
import script from "./SmeBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeBadge.vue?vue&type=style&index=0&id=17de6a2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de6a2a",
  null
  
)

export default component.exports